import React from 'react';
import { CheckCircle, AlertCircle, Info, AlertTriangle, X } from 'lucide-react';
import { useToast } from '../context/ToastContext';
import './Toast.css';

const toastIcons = {
  success: CheckCircle,
  error: AlertCircle,
  info: Info,
  warning: AlertTriangle,
};

function Toast() {
  const { toast, clearToast } = useToast();
  if (!toast.visible || !toast.message) return null;

  const Icon = toastIcons[toast.type] || Info;

  return (
    <div
      className={`toast toast-${toast.type}`}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <Icon size={18} strokeWidth={2.5} className="toast-icon" />
      <span className="toast-message">{toast.message}</span>
      <button
        type="button"
        className="toast-close"
        onClick={clearToast}
        aria-label="Close"
      >
        <X size={16} strokeWidth={2} />
      </button>
    </div>
  );
}

export default Toast;
